// LiveConfirmModal — lifted out of the LiveTrading component body (God 2026-08-26,
// phase 4). Typed GO-LIVE confirmation — the gate between paper and real money.
//
// Phases 1-3 moved top-level declarations, which close over nothing. This block
// lived INSIDE the component and closed over its state, so it could not be moved
// verbatim — it needed a prop for every name it borrowed. That prop list was
// computed by intersecting the block's identifiers with the component's scope
// (tools/refactor_livetrading_phase4.py), not written by hand: a hand-listed
// prop set is exactly where a missed dependency becomes a runtime undefined that
// the compiler never sees.
//
// Every prop keeps its ORIGINAL LOCAL NAME, so the JSX below is the original
// text. Behaviour is unchanged by construction.

import React from 'react';

export interface LiveConfirmModalProps {
  confirmLiveSwitch: any;
  liveConfirmFor: any;
  liveConfirmText: any;
  newDep: any;
  setLiveConfirmText: any;
  setShowLiveConfirm: any;
  showLiveConfirm: any;
}

export const LiveConfirmModal: React.FC<LiveConfirmModalProps> = ({ confirmLiveSwitch, liveConfirmFor, liveConfirmText, newDep, setLiveConfirmText, setShowLiveConfirm, showLiveConfirm }) => (
  <>
        {/* LIVE trading activation modal — typed "GO LIVE" required so a single
            mis-tap can't flip real-money mode on. */}
        {showLiveConfirm && (
          <div onClick={() => setShowLiveConfirm(false)} style={{
            position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.85)',
            zIndex: 10000, display: 'flex', alignItems: 'center', justifyContent: 'center',
          }}>
            <div onClick={e => e.stopPropagation()} style={{
              background: '#0f172a', border: '2px solid #ef4444', borderRadius: 10,
              padding: 28, maxWidth: 460, boxShadow: '0 30px 80px rgba(239,68,68,0.5)',
            }}>
              <div style={{ fontSize: 22, fontWeight: 900, color: '#ef4444', marginBottom: 12 }}>
                {typeof liveConfirmFor === 'number' ? '🚨 IS SYMBOL KO LIVE KARNA HAI?' : liveConfirmFor === 'BOT' ? '🚨 IS BOT KO LIVE KARNA HAI?' : '🚨 LIVE VIEW ACTIVATION'}
              </div>
              <div style={{ fontSize: 13, color: '#fca5a5', lineHeight: 1.6, marginBottom: 14 }}>
                {typeof liveConfirmFor === 'number' ? (
                  <>
                    <strong style={{ color: '#fff' }}>Sirf {newDep.assets?.[liveConfirmFor]?.symbol || 'yeh symbol'}</strong> real
                    money par aayega — is symbol ke signals par REAL broker orders firenge; basket ke baaki
                    symbols apne mode (BOT/PAPER) par hi rahenge. Type karo{' '}
                  </>
                ) : liveConfirmFor === 'BOT' ? (
                  <>
                    <strong style={{ color: '#fff' }}>Sirf yeh bot</strong> real money par aayega — iske
                    har signal par broker ko REAL order jayega (baaki PAPER bots test me hi rahenge).
                    Aage badhne ke liye type karo{' '}
                  </>
                ) : (
                  <>
                    Dashboard <strong style={{ color: '#fff' }}>LIVE view</strong> par aayega (LIVE ledger/stats).
                    Bots ke modes nahi badlenge — LIVE bot sirf modal ke TRADING MODE se banta hai. Type karo{' '}
                  </>
                )}
                <span style={{ fontFamily: 'monospace', background: '#1f2937', padding: '2px 8px', borderRadius: 4, color: '#fbbf24' }}>GO LIVE</span>{' '}
                below.
              </div>
              <input autoFocus value={liveConfirmText} onChange={e => setLiveConfirmText(e.target.value)}
                placeholder="Type GO LIVE"
                onKeyDown={e => { if (e.key === 'Enter') confirmLiveSwitch(); else if (e.key === 'Escape') setShowLiveConfirm(false); }}
                style={{
                  width: '100%', padding: '10px 12px', background: '#060810',
                  border: '1px solid #374151', borderRadius: 6, color: '#fff',
                  fontSize: 14, fontFamily: 'monospace', letterSpacing: 2,
                  outline: 'none', marginBottom: 16,
                }} />
              <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
                <button onClick={() => setShowLiveConfirm(false)} style={{
                  minHeight: 48, padding: '8px 18px', background: 'transparent', color: '#9ca3af',
                  border: '1px solid #374151', borderRadius: 6, cursor: 'pointer', fontSize: 12,
                }}>Cancel</button>
                <button onClick={confirmLiveSwitch}
                  disabled={liveConfirmText.trim().toUpperCase() !== 'GO LIVE'}
                  style={{
                    minHeight: 48, padding: '8px 22px',
                    background: liveConfirmText.trim().toUpperCase() === 'GO LIVE' ? '#ef4444' : '#1f2937',
                    color: liveConfirmText.trim().toUpperCase() === 'GO LIVE' ? '#fff' : '#64748b',
                    border: 'none', borderRadius: 6, cursor: liveConfirmText.trim().toUpperCase() === 'GO LIVE' ? 'pointer' : 'not-allowed',
                    fontSize: 12, fontWeight: 800, letterSpacing: 1,
                  }}>Activate LIVE</button>
              </div>
            </div>
          </div>
        )}
  </>
);
